// extracted by mini-css-extract-plugin
export default {"root":"InfoSection_root__ccfk0","card":"InfoSection_card__zE74J","texts":"InfoSection_texts__6Hmpq"};